import React, { useState } from 'react';
import { Send, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  
  // Target email where all notifications will be sent
  const notificationEmail = 'balajitramesh0402@gmail.com';

  const handleSendEmail = () => {
    if (email && email.trim() !== '') {
      // In a real implementation, this would connect to a backend API or email service
      // The following is for demonstration purposes
      const emailData = {
        subscriberEmail: email,
        notificationTo: notificationEmail,
        message: `New subscription from ${email}`,
        timestamp: new Date().toISOString()
      };
      
      console.log('Sending notification with data:', emailData);
      
      // This is where you would make the actual API call to your email service
      // For example:
      // fetch('/api/send-notification', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(emailData)
      // });
      
      setEmailSent(true);
      setTimeout(() => setEmailSent(false), 3000);
      setEmail('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendEmail();
    }
  };

  return (
    <footer className="bg-black text-white p-8">
      <div className="container mx-auto mt-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 pb-12">
          {/* Subscribe Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              {/* SVG Circles */}
              <img src="/assets/Group 4.svg" alt="circle" />
            </div>
            <h3 className="text-lg font-medium">Subscribe</h3>
            <p className="text-sm">Get 10% off your first order</p>
            <div className="flex relative">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-2 bg-transparent border border-white text-white text-sm w-full"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <button 
                className="bg-transparent p-2 absolute right-0 top-0 h-full"
                onClick={handleSendEmail}
                aria-label="Subscribe"
              >
                <Send size={16} className="text-white" />
              </button>
            </div>
            {emailSent && (
              <div className="text-green-400 text-xs">
                Thank you! Notification sent to admin.
              </div>
            )}
          </div>

          {/* Support Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-medium">Support</h3>
            <ul className="space-y-6 text-sm">
              <li>No.04 Hariram Rd, <br/>Tiruppur, TamilNadu</li>
              <li></li>
              <li>example@gmail.com</li>
              <li>+00 0000 0000</li>
            </ul>
          </div>

          {/* Account Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-medium">Account</h3>
            <nav>
              <ul className="space-y-5 text-sm">
                <li><a href="#" className="hover:underline">My Account</a></li>
                <li><a href="#" className="hover:underline">Login / Register</a></li>
                <li><a href="#" className="hover:underline">Cart</a></li>
                <li><a href="#" className="hover:underline">Wishlist</a></li>
                <li><a href="#" className="hover:underline">Shop</a></li>
              </ul>
            </nav>
          </div>

          {/* Quick Link Section */}
          <div className="space-y-3">
            <h3 className="text-lg font-medium">Quick Link</h3>
            <nav>
              <ul className="space-y-6 text-sm">
                <li><a href="#" className="hover:underline">Privacy Policy</a></li>
                <li><a href="#" className="hover:underline">Terms Of Use</a></li>
                <li><a href="#" className="hover:underline">FAQ</a></li>
                <li><a href="contact" className="hover:underline">Contact</a></li>
              </ul>
            </nav>
          </div>

          {/* Social Media Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Social Media</h3>
            <nav>
              <ul className="flex space-x-6 text-sm">
                <li><a href="#" className="hover:text-gray-300 p-2"><Facebook size={22} /></a></li>
                <li><a href="#" className="hover:text-gray-300 p-2"><Twitter size={22} /></a></li>
                <li><a href="#" className="hover:text-gray-300 p-2"><Instagram size={22} /></a></li>
                <li><a href="#" className="hover:text-gray-300 p-2"><Linkedin size={22} /></a></li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Copyright - Centered */}
        <hr/>
        <div className="text-center pt-4 pb-6">
          <p className="text-sm text-gray-300">© Copyright Mr.Alden 2024. All right reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;